import uniqBy from 'lodash/uniqBy';

import {
  IssueSearchResponse,
  QAlityFilterestTestCasesParams,
  defaultFilters,
} from '@qality/common-model';
import { IssuesAndTotal } from '@qality/common-model/src/JQLSearch';
import { JQLSearchUtils } from '@qality/common-utils/src/JQLSearchUtils';

import API from './API';

const getIssuesByJql = async (
  jql: string,
  startAt = 0,
  maxResults = JQLSearchUtils.MAX_SEARCH_RESULTS,
  retry = true
): Promise<IssuesAndTotal> => {
  const requestArgs = {
    url: '/rest/api/2/search',
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      jql,
      maxResults,
      fields: JQLSearchUtils.DEFAULT_FIELDS,
      startAt,
    }),
  };

  const result = await API[retry ? 'request' : 'noRetry'](requestArgs).then(
    (response) => {
      return JSON.parse(response.body);
    }
  );

  return {
    issues: result.issues,
    total: result.total,
  };
};

const getQAlityFilteredTestCasesByText = async (
  startAt = 0,
  maxResults = JQLSearchUtils.MAX_SEARCH_RESULTS,
  filters = defaultFilters
): Promise<IssuesAndTotal> => {
  const jqlWithTextSearch = JQLSearchUtils.buildJqlQuery(filters, 'text');

  return await getIssuesByJql(jqlWithTextSearch, startAt, maxResults);
};

const getQAlityFilteredTestCasesByKeys = async (
  keys: Array<string>,
  startAt = 0,
  maxResults = JQLSearchUtils.MAX_SEARCH_RESULTS,
  filters = defaultFilters
): Promise<IssueSearchResponse> => {
  const jqlWithKeySearch = JQLSearchUtils.buildJqlQuery(filters, 'keys', keys);

  return await getIssuesByJql(jqlWithKeySearch, startAt, maxResults, false);
};

const getQAlityFilteredTestCasesServer = async ({
  startAt = 0,
  maxResults = JQLSearchUtils.MAX_SEARCH_RESULTS,
  filters = defaultFilters,
}: QAlityFilterestTestCasesParams): Promise<IssuesAndTotal> => {
  const issuesWithText = await getQAlityFilteredTestCasesByText(
    startAt,
    maxResults,
    filters
  );

  const keys = JQLSearchUtils.getValidIssueKeysFromText(filters.text);
  if (keys.length != 0) {
    try {
      const issuesByKeys = await getQAlityFilteredTestCasesByKeys(
        keys,
        startAt,
        maxResults,
        filters
      );

      return {
        issues: uniqBy(
          [...issuesWithText.issues, ...issuesByKeys.issues],
          (issue) => issue.key
        ),
        total: issuesWithText.total + issuesByKeys.total,
      };
    } catch (error) {
      return issuesWithText;
    }
  }
  return issuesWithText;
};

export default {
  getIssuesByJql,
  getQAlityFilteredTestCasesServer,
};
